export default __webpack_public_path__ + "static/media/mobileBackground.c5492c18.jpg";